import { useMemo, useState } from 'react'

import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { findExcursionsStore } from 'entities/excursions/models/find-excursions/find-excursions-store'
import { listExcursionStore } from 'entities/excursions/models/list-excursions/list-excursions-state'

import { IExcursionsGuides } from 'shared/api/excursions/list/model'

import { ExcursionsFilterCarrierUi } from './components/filter-carrier-ui/filter-carrier-ui'
import s from './styles.module.scss'

export interface SelectedGuides extends IExcursionsGuides {
  selected?: boolean
}

const prepareSelected = (
  guides?: IExcursionsGuides[],
  selectedIds?: string[],
) => {
  return guides?.map((guide) => ({
    ...guide,
    selected: selectedIds?.includes(guide.id),
  }))
}

export const FilterGuides = observer(() => {
  const navigate = useNavigate()

  const guides = listExcursionStore.getGuides()

  const { filter } = findExcursionsStore.findExcursions

  const [guidesState, setGuidesState] = useState<SelectedGuides[]>(() => {
    if (filter?.guides_id) {
      return prepareSelected(guides, filter?.guides_id) || []
    }

    return guides || []
  })

  const onReset = () => {
    setGuidesState(guides || [])
  }

  const onBack = () => {
    navigate(-1)
  }
  const onSelectCarrier = (index: number) => {
    const copyState = [...guidesState]

    copyState[index].selected = !Boolean(copyState[index]?.selected)

    setGuidesState(copyState)
  }

  const onApply = () => {
    const selectedGuides = guidesState
      ?.filter((guide) => guide.selected)
      ?.map((guide) => guide.id)

    findExcursionsStore.onSelectGuides(selectedGuides)

    navigate(RoutingPaths.excursion.search.path())

    listExcursionStore.resetList()
  }

  const canDisabled = useMemo(
    () => guidesState?.some((item) => item.selected),
    [guidesState],
  )

  return (
    <div className={clsx('container', s.container)}>
      <ExcursionsFilterCarrierUi
        titleKey="guides"
        state={guidesState}
        canDisabled={canDisabled}
        onBack={onBack}
        onApply={onApply}
        onReset={onReset}
        onSelect={onSelectCarrier}
      />
    </div>
  )
})

export default FilterGuides
